(function($) {
  "use strict";

  // helpers
  function debounce(fn, wait) {
    var t;
    return function() {
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function() { fn.apply(ctx, args); }, wait);
    };
  }

  function onIdle(fn) {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(fn, { timeout: 1000 });
    } else {
      setTimeout(fn, 200);
    }
  }

  // initialize slick safely
  function initSlick($el, opts) {
    if (!$el || !$el.length) return;
    if ($el.data('_slick_inited')) return;
    try {
      $el.slick(opts || { infinite: true });
      $el.data('_slick_inited', true);
    } catch (e) {
      // silent
    }
  }

  // initialize owl safely
  function initOwl($el, opts) {
    if (!$el || !$el.length) return;
    if ($el.data('_owl_inited')) return;
    try {
      $el.owlCarousel(opts || $el.data('owl-carousel') || {});
      $el.data('_owl_inited', true);
    } catch (e) {
      // silent
    }
  }

  // lazy-init when visible
  function lazyInit(selector, initFn) {
    var els = document.querySelectorAll(selector);
    if (!els || els.length === 0) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            onIdle(function() { initFn($(entry.target)); });
            observer.unobserve(entry.target);
          }
        });
      }, { root: null, rootMargin: '200px', threshold: 0.01 });

      els.forEach(function(el) { io.observe(el); });
    } else {
      // fallback - init after small delay
      setTimeout(function() {
        els.forEach(function(el) { initFn($(el)); });
      }, 300);
    }
  }

  $(function() {

    // Menu stick - debounce scroll
    var header = $('.sticky-bar');
    var $win = $(window);
    $win.on('scroll', debounce(function() {
      var scroll = $win.scrollTop();
      if (scroll < 200) {
        header.removeClass('stick');
      } else {
        header.addClass('stick');
      }
    }, 60));

    // Cart active
    (function cartActive() {
      var $cartWrap = $('.cart-wrap');
      if (!$cartWrap.length) return;
      var $body = $('body'),
          $cartContent = $cartWrap.find('.shopping-cart-content');

      $cartWrap.on('click', '.icon-cart-active', function(e) {
        e.preventDefault();
        var $this = $(this);
        var $parent = $this.parent();
        var $content = $this.siblings('.shopping-cart-content');
        if (!$parent.hasClass('show')) {
          $content.addClass('show'); $parent.addClass('show');
        } else {
          $content.removeClass('show'); $parent.removeClass('show');
        }
      });

      $cartWrap.on('click', '.cart-close', function(e) {
        e.preventDefault();
        $(this).closest('.cart-wrap').removeClass('show').find('.shopping-cart-content').removeClass('show');
      });

      $body.on('click', function(e) {
        var $target = e.target;
        if (!$($target).is('.cart-wrap') && !$($target).parents().is('.cart-wrap') && $cartWrap.hasClass('show')) {
          $cartWrap.removeClass('show');
          $cartContent.removeClass('show');
        }
      });
    })();

    // Setting active
    (function settingActive() {
      var $parloDropdown2 = $('.setting-wrap');
      if (!$parloDropdown2.length) return;
      var $body2 = $('body'),
          $parloDropdownMenu2 = $parloDropdown2.find('.setting-content');

      $parloDropdown2.on('click', '.setting-active', function(e) {
        e.preventDefault();
        var $this = $(this);
        var $parent = $this.parent();
        var $content = $this.siblings('.setting-content');
        if (!$parent.hasClass('show')) {
          $content.addClass('show').slideDown().parent().addClass('show');
        } else {
          $content.removeClass('show').slideUp().parent().removeClass('show');
        }
      });

      $body2.on('click', function(e) {
        var $target = e.target;
        if (!$($target).is('.setting-wrap') && !$($target).parents().is('.setting-wrap') && $parloDropdown2.hasClass('show')) {
          $parloDropdown2.removeClass('show');
          $parloDropdownMenu2.removeClass('show').slideUp();
        }
      });
    })();

    // Section loader for Shopify editor - keep behavior, but defer heavy inits
    $(document).on('shopify:section:load', function(e){
      $('#' + e.target.id).find('[data-section]').sectionJs();
    }).ready(function() {
      $('[data-section]').each(function(){ $(this).sectionJs(); });
    });

    $.fn.sectionJs = function(){
      var $this = this;
      var name = $this.data('section');
      switch (name) {
        case "BrandSlider": lazyInitSelector($this, '.brand_slider_active', initSlick); break;
        case "Simple_Banner": lazyInitSelector($this, '.banner-slider-active', initSlick); break;
        case "Bestx_Collections": lazyInitSelector($this, '.bestcol-slider-active', initSlick); break;
        case "Collection_Banner": lazyInitSelector($this, '.collection-slider-active', initSlick); break;
        case "Feature_Collection": lazyInitSelector($this, '.feature-product-slider-active', initSlick); break;
        case "Tab_With_Products": lazyInitSelector($this, '.product-slider-active', initSlick); break;
        case "Latest_Blog": lazyInitSelector($this, '.blog-slider-active', initSlick); break;
        case "About_team": lazyInitSelector($this, '.banner-slider-active-team', initSlick); break;
        case "Related_Products": lazyInitSelector($this, '.related-feature-product-slider-active', initSlick); break;
        case "Custom_Collection": lazyInitSelector($this, '.custom-feature-product-slider-active', initSlick); break;
        case "heroOwlSlider": lazyInitSelector($this, '[data-owl-carousel]', initOwl); break;
        default: break;
      }

      function lazyInitSelector(context, sel, fn) {
        var $sel = context.find(sel);
        if ($sel.length) {
          // observe each child for visibility
          $sel.each(function() { lazyInit(this, function($el) { fn($el); }); });
        }
      }
    };

    // Generic slick init for elements that are present on page
    onIdle(function() {
      // Lazy-init all slick-ish selectors (basic fallback init)
      lazyInit('.brand_slider_active', initSlick);
      lazyInit('.banner-slider-active', initSlick);
      lazyInit('.bestcol-slider-active', initSlick);
      lazyInit('.collection-slider-active', initSlick);
      lazyInit('.feature-product-slider-active', initSlick);
      lazyInit('.product-slider-active', initSlick);
      lazyInit('.blog-slider-active', initSlick);
      lazyInit('.banner-slider-active-team', initSlick);
      lazyInit('.related-feature-product-slider-active', initSlick);
      lazyInit('.custom-feature-product-slider-active', initSlick);
      lazyInit('[data-owl-carousel]', function($el) { initOwl($el, $el.data('owl-carousel') || {}); });
    });

    // Specific sliders that were directly initialized - lazy + debounce
    function setupProductSliderActive2() {
      var $el = $('.product-slider-active-2');
      if (!$el.length) return;
      lazyInit('.product-slider-active-2', function($node) {
        initOwl($node, {
          loop: true,
          nav: false,
          autoplay: false,
          autoplayTimeout: 5000,
          animateOut: 'fadeOut',
          animateIn: 'fadeIn',
          item: 3,
          margin: 30,
          responsive: {
            0: { items: 1 },
            576: { items: 2 },
            768: { items: 2 },
            992: { items: 3 },
            1200: { items: 3 }
          }
        });
      });
    }
    setupProductSliderActive2();

    // Quickview slider
    lazyInit('.quickview-slide-active', function($node) {
      initOwl($node, {
        loop: true,
        navText: ["<i class='sli sli-arrow-left'></i>", "<i class='sli sli-arrow-right'></i>"],
        margin: 15,
        smartSpeed: 1000,
        nav: true,
        dots: false,
        responsive: {
          0: { items: 3, autoplay: true, smartSpeed: 300 },
          576: { items: 3 },
          768: { items: 3 },
          1000: { items: 3 }
        }
      });
    });

    // Cart Plus Minus
    (function cartPlusMinus() {
      var CartPlusMinus = $('.cart-plus-minus');
      if (!CartPlusMinus.length) return;
      CartPlusMinus.prepend('<div class="dec qtybutton">-</div>');
      CartPlusMinus.append('<div class="inc qtybutton">+</div>');
      CartPlusMinus.on("click", ".qtybutton", function() {
        var $button = $(this);
        var $input = $button.parent().find("input");
        var oldValue = parseFloat($input.val()) || 0;
        var newVal = oldValue;
        if ($button.text() === "+") newVal = oldValue + 1;
        else newVal = (oldValue > 1) ? oldValue - 1 : 1;
        $input.val(newVal).trigger('change');
      });
    })();

    // onload tasks - deferred
    $(window).on('load', function() {
      onIdle(function() {
        // item toggler (instagram / load more)
        (function itemToggler() {
          $(".toggle-item-active").slice(0, 4).show();
          $(".item-wrapper").find(".loadMore").on('click', function(e) {
            e.preventDefault();
            $(this).parents(".item-wrapper").find(".toggle-item-active:hidden").slice(0, 4).slideDown();
            if ($(".toggle-item-active:hidden").length === 0) {
              $(this).parent('.toggle-btn').fadeOut('slow');
            }
          });
        })();

        // Scroll reveal (if available)
        var $scroll_zoom_var = $('.scroll-zoom');
        if ($scroll_zoom_var.length && window.ScrollReveal) {
          window.sr = window.sr || ScrollReveal({ duration: 800, reset: false });
          sr.reveal('.scroll-zoom');
        }

        // scrollUp plugin init (if present)
        if ($.scrollUp) {
          $.scrollUp({
            scrollText: '<i class="sli sli-arrow-up"></i>',
            easingType: 'linear',
            scrollSpeed: 900,
            animation: 'fade'
          });
        }

        // mobile off-canvas
        (function headermobileAside() {
          var navbarTrigger = $('.mobile-aside-button'),
              endTrigger = $('.mobile-aside-close'),
              container = $('.mobile-off-canvas-active'),
              wrapper = $('.wrapper');
          if (!wrapper.length) return;
          if (!$('.body-overlay').length) wrapper.prepend('<div class="body-overlay"></div>');
          navbarTrigger.on('click', function(e) {
            e.preventDefault();
            container.addClass('inside');
            wrapper.addClass('overlay-active');
          });
          endTrigger.on('click', function() {
            container.removeClass('inside');
            wrapper.removeClass('overlay-active');
          });
          $('.body-overlay').on('click', function() {
            container.removeClass('inside');
            wrapper.removeClass('overlay-active');
          });
        })();

        // mobile toggles
        $('.mobile-language-active').on('click', function(e) {
          e.preventDefault(); $('.lang-dropdown-active').slideToggle(300);
        });
        $('.mobile-currency-active').on('click', function(e) {
          e.preventDefault(); $('.curr-dropdown-active').slideToggle(300);
        });
        $('.mobile-account-active').on('click', function(e) {
          e.preventDefault(); $('.account-dropdown-active').slideToggle(300);
        });

        // off-canvas mobile menu toggles
        (function mobileMenu() {
          var $offCanvasNav = $('.mobile-menu');
          if (!$offCanvasNav.length) return;
          var $offCanvasNavSubMenu = $offCanvasNav.find('.dropdown');
          $offCanvasNavSubMenu.parent().prepend('<span class="menu-expand"><i></i></span>');
          $offCanvasNavSubMenu.slideUp();
          $offCanvasNav.on('click', 'li a, li .menu-expand', function(e) {
            var $this = $(this);
            if (($this.parent().attr('class') || '').match(/\b(menu-item-has-children|has-children|has-sub-menu)\b/) && ($this.attr('href') === '#' || $this.hasClass('menu-expand'))) {
              e.preventDefault();
              if ($this.siblings('ul:visible').length) {
                $this.parent('li').removeClass('active');
                $this.siblings('ul').slideUp();
              } else {
                $this.parent('li').addClass('active');
                $this.closest('li').siblings('li').removeClass('active').find('li').removeClass('active');
                $this.closest('li').siblings('li').find('ul:visible').slideUp();
                $this.siblings('ul').slideDown();
              }
            }
          });
        })();

        // Price slider (jquery-ui) - keep same logic
        (function priceSlider() {
          var sliderrange = $('#slider-range');
          var amountprice = $('#amount');
          if (!sliderrange.length || !amountprice.length || !$.fn.slider) return;
          sliderrange.slider({
            range: true,
            min: 16,
            max: 400,
            values: [0, 300],
            slide: function(event, ui) {
              amountprice.val("$" + ui.values[0] + " - $" + ui.values[1]);
            }
          });
          amountprice.val("$" + sliderrange.slider("values", 0) + " - $" + sliderrange.slider("values", 1));
        })();

        // Product detail sliders lazy-init
        lazyInit('.product-dec-slider', function($node) {
          initSlick($node, {
            infinite: true,
            arrows: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            prevArrow: '<span class="product-dec-icon product-dec-prev"><i class="sli sli-arrow-left"></i></span>',
            nextArrow: '<span class="product-dec-icon product-dec-next"><i class="sli sli-arrow-right"></i></span>',
            responsive: [
              { breakpoint: 1199, settings: { slidesToShow: 3, slidesToScroll: 1 } },
              { breakpoint: 768, settings: { slidesToShow: 3, slidesToScroll: 1 } },
              { breakpoint: 767, settings: { slidesToShow: 4, slidesToScroll: 1 } },
              { breakpoint: 575, settings: { slidesToShow: 2, slidesToScroll: 1 } }
            ]
          });
        });

        lazyInit('.product-dec-slider-2', function($node) {
          initSlick($node, {
            infinite: true,
            slidesToShow: 4,
            vertical: true,
            slidesToScroll: 1,
            centerPadding: '60px',
            prevArrow: '<span class="product-dec-icon product-dec-prev"><i class="sli sli-arrow-up"></i></span>',
            nextArrow: '<span class="product-dec-icon product-dec-next"><i class="sli sli-arrow-down"></i></span>',
            responsive: [
              { breakpoint: 1199, settings: { slidesToShow: 4, slidesToScroll: 1 } },
              { breakpoint: 991, settings: { slidesToShow: 4, slidesToScroll: 1 } },
              { breakpoint: 767, settings: { slidesToShow: 4, slidesToScroll: 1 } },
              { breakpoint: 575, settings: { slidesToShow: 2, slidesToScroll: 1 } }
            ]
          });
        });

        // clickable menu
        var $click_menu = $('#menu');
        if ($click_menu.length) {
          try { $('#menu').slinky(); } catch(e) {}
          (function sidebarMainmenu() {
            var menuTrigger = $('.clickable-mainmenu-active'),
                endTrigger = $('button.clickable-mainmenu-close'),
                container = $('.clickable-mainmenu');
            menuTrigger.on('click', function(e) {
              e.preventDefault(); container.addClass('inside');
            });
            endTrigger.on('click', function() {
              container.removeClass('inside');
            });
          })();
        }

        // center mode slider
        lazyInit('.slider-active-cmode', function($node) {
          initSlick($node, {
            dots: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            centerMode: true,
            centerPadding: '260px',
            prevArrow: '<span class="product-dec-icon product-dec-prev"><i class="sli sli-arrow-left"></i></span>',
            nextArrow: '<span class="product-dec-icon product-dec-next"><i class="sli sli-arrow-right"></i></span>',
            responsive: [
              { breakpoint: 1199, settings: { slidesToShow: 1, centerPadding: '100px' } },
              { breakpoint: 762, settings: { slidesToShow: 1, centerPadding: '60px' } },
              { breakpoint: 580, settings: { slidesToShow: 1, centerPadding: '0px' } }
            ]
          });
        });

        // category "show more"
        $(".category-item-parent.hidden").hide();
        $(".more-btn").on('click', function(e) {
          e.preventDefault();
          $(".category-item-parent.hidden").toggle(500);
          var htmlAfter = "Hide More Type";
          var htmlBefore = "Show More Type";
          $(this).html($(this).text() == htmlAfter ? htmlBefore : htmlAfter);
          $(this).toggleClass("minus");
        });

        // video popup
        lazyInit('.video-popup', function($node) {
          try {
            $node.magnificPopup({
              type: 'iframe',
              mainClass: 'mfp-fade',
              removalDelay: 160,
              preloader: false,
              zoom: { enabled: true }
            });
          } catch(e){}
        });

        // image popup
        lazyInit('.img-popup', function($node) {
          try {
            $node.magnificPopup({ type: 'image', gallery: { enabled: true } });
          } catch(e){}
        });

        // sidebar sticky
        if ($.fn.stickySidebar) {
          var $sidebar_active_var = $('.sidebar-active');
          if ($sidebar_active_var.length) {
            $sidebar_active_var.stickySidebar({ topSpacing: 80, bottomSpacing: 30, minWidth: 767 });
          }
        }

        // checkout toggles
        $('.checkout-click1').on('click', function(e) { e.preventDefault(); $('.checkout-login-info').slideToggle(900); });
        $('.checkout-click3').on('click', function(e) { e.preventDefault(); $('.checkout-login-info3').slideToggle(1000); });
        $('.checkout-toggle2').on('click', function() { $('.open-toggle2').slideToggle(1000); });
        $('.checkout-toggle').on('click', function() { $('.open-toggle').slideToggle(1000); });

        // payment box toggles
        var checked = $('.sin-payment input:checked');
        if (checked.length) { $(checked).siblings('.payment-box').slideDown(900); }
        $('.sin-payment input').on('change', function() {
          $('.payment-box').slideUp(900);
          $(this).siblings('.payment-box').slideToggle(900);
        });

        // remove href placeholders
        $('.remove_href').removeAttr('href');

        // product image slider
        lazyInit('.theme-product-image-slider', function($node) {
          initSlick($node, {
            dots: true,
            arrows: true,
            prevArrow: '<button class="slick-prev"><i class="sli sli-arrow-left"></i></button>',
            nextArrow: '<button class="slick-next"><i class="sli sli-arrow-right"></i></button>'
          });
        });

        // color category click handlers
        $('.color-categories').on('click', '.variant_img', function() {
          var variantImage = $(this).parent().find('.variant_img a img').attr('src');
          $(this).parents('.pgrid_9').find('.theme-product-image .pgrid_9_img a img').attr('src', variantImage);
          return false;
        });

        $('.p_select a').addClass('active');
        $('.color-categories').on('click', '.variant_img a', function() {
          $('.color-categories li .variant_img a.active').removeClass('active');
          $(this).addClass('active');
        });

      }); // end onIdle in load
    }); // end window load

    // product grid color variant click
    $(document).on('click', '.product-color li label', function() {
      var variantImage = $(this).parent().find('.hidden a').attr('href');
      $(this).parents('.product-wrapper-class').find('.popup_cart_image').attr('src', variantImage);
      return false;
    });

    // Sticky Add To Cart functionality (kept same logic but debounced scroll)
    function proStikcyAddToCart() {
      var $stikcyParent = $('.pro_sticky_atc');
      if (!$stikcyParent.length) return;

      var $proVarintActive = $stikcyParent.find('.Pro_variant__active'),
          $stickyProVarItem = $stikcyParent.find('.pro_variant_swatch');

      $stickyProVarItem.off('click.activeVar').on('click.activeVar', function(e) {
        var $this = $(this),
            $text = $this.text(),
            $StickyVarval = $this.data('value'),
            $varnewImg = $this.data('img'),
            $newqty = $this.data('quantity');

        $stickyProVarItem.removeClass('active');
        $this.addClass('active');

        $stikcyParent.find('.sticky__pro_add_cart input[type=hidden]').val($StickyVarval);
        $proVarintActive.attr('data-value', $StickyVarval).text($text);

        var $variantSwtval = $('#AddToCartForm [data-value-sticky="'+$StickyVarval+'"]');
        $variantSwtval.each(function() {
          var $switem = $(this).data('value');
          $('[data-value="'+$switem+'"]').closest('.swatch').find('#'+$switem).click();
        });

        $('.sticky_pro_img img').attr('src', $varnewImg);
        $('.sticky__qty input').attr('totalqty', $newqty);

        return false;
      });

      // Select option synchronization
      (function syncSelectors() {
        var $optionSelected = $('#product-selectors option:selected');
        var $StickyVarval = $optionSelected.val();
        var $prostickyActive = $stikcyParent.find('.pro_variant_swatch[data-value="'+$StickyVarval+'"]');
        var $prostickyText = $prostickyActive.html();

        $proVarintActive.html($prostickyText);
        $prostickyActive.addClass('active');

        var $datastr = $prostickyActive.data('img');
        $('.sticky_pro_img img').attr('src', $datastr);

        $(".swatch .swatch-element").each(function() {
          var $varid = $(this).find('input:radio').attr('id');
          $('.swatch input.text[data-value="'+$varid+'"]').appendTo($(this));
        });

        $('.selector-wrapper').on('change', function() {
          var $proSelectors = $("#product-selectors").val();
          $('.pro_sticky_atc .pro_variant__options li').each(function() {
            var $varSinItem = $(this).find('a').data('value');
            if ($varSinItem == $proSelectors) $(this).find('a').addClass('active');
            else $(this).find('a').removeClass('active');
          });

          $("#product-selectors").on('change', function() {
            var $varstr = "";
            $("#product-selectors option:selected").each(function() { $varstr += $(this).data('imge'); });
            $('.sticky_pro_img img').attr('src', $varstr);
          }).trigger("change");

          if ($stickyProVarItem.hasClass('active')) {
            var $StikcyVarhtml = $('.pro_sticky_atc .pro_variant_swatch.active').html();
            $('.pro_sticky_atc .sticky__pro_add_cart input[type=hidden]').val($proSelectors);
            $proVarintActive.html($StikcyVarhtml);
            $proVarintActive.attr('data-value', $proSelectors);
          }
        });

      })();

      // Product scroll sticky class - debounced
      var offSetTopEl = $('.sticky__pro_button');
      if (offSetTopEl.length) {
        var offSetTop = offSetTopEl.offset().top;
        $(window).on('scroll', debounce(function () {
          var scrollTop = $(this).scrollTop();
          if (scrollTop > offSetTop) $('body').addClass('atc_sticky_scoll');
          else $('body').removeClass('atc_sticky_scoll');
        }, 50));
      }

      // Sticky quantity buttons
      $('.quantity_inner').on('click', '.dec_btn, .inc_btn', function(e) {
        var $qty_field = $(this).parent().find('input');
        var $qtCount = parseInt($qty_field.val(), 10) + (e.currentTarget.className === 'inc_btn' ? 1 : -1);
        $qty_field.val($qtCount).change();
      });

      $('.quantity_inner').on('change', 'input', function() {
        var $this = $(this);
        var $min = 1;
        var $value = parseInt($this.val(), 10);
        var $max = parseInt($this.attr('totalqty'), 10) || $value;
        $value = Math.min($value, $max);
        $value = Math.max($value, $min);
        $this.val($value);
      }).on("keypress", function(e) {
        if (e.keyCode === 13) { e.preventDefault(); }
      });

    } // end proStikcyAddToCart

    proStikcyAddToCart();

    // LookBook JS
    function lookbookkjs(){
      var clothTag = $('.cloth-tag');
      if (!clothTag.length) return;
      clothTag.each(function(){
        var $this = $(this),
            topValue = $this.data('top'),
            leftValue = $this.data('left');
        $this.css({"top": topValue, "left": leftValue});
      });

      $('.cloth-tag__icon').on('click', function(e) {
        $(this).siblings('.cloth-tag__content').addClass('active'); e.stopPropagation();
      });

      $('.lookbook_close__icon').on('click', function(e){
        $(this).parent('.cloth-tag__content').removeClass('active'); e.stopPropagation();
      });

      $('body').on('click', function(e) {
        if (!$(e.target).is('.cloth-tag__content.active')) $('.cloth-tag__content.active').removeClass('active');
      });
    }
    lookbookkjs();

  }); // end document ready

})(jQuery);